exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner[data-v-74ba4788]{width:60px;height:60px;border:4px solid #23b32f;border-right-color:transparent;border-radius:50%;position:relative;-webkit-animation:loader-rotate-data-v-74ba4788 1s linear infinite;animation:loader-rotate-data-v-74ba4788 1s linear infinite}.spinner[data-v-74ba4788]:after{content:\"\";width:4px;height:4px;background:#23b32f;border-radius:50%;position:absolute;top:4px;left:44px}@-webkit-keyframes loader-rotate-data-v-74ba4788{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@keyframes loader-rotate-data-v-74ba4788{0%{transform:rotate(0)}to{transform:rotate(1turn)}}", ""]);

// exports
